export const russianYear = (numb: number) =>
  numb === 1
    ? 'год'
    : numb < 5 && numb > 1
    ? 'года'
    : numb > 20 && ['1', '2', '3', '4'].includes(`${numb}`.slice(-1)[0])
    ? 'года'
    : 'лет';
